import App from 'app/app.js';
import 'app/service/RouterService.js';
import 'app/service/StatsdService.js';
import 'app/store/UserProfileStore.js';
import 'app/store/MessageStore.js';

const VERSION_ENDPOINT = './api/frontend-version';

// Cohorts the server placed on a build on purpose; prompting would offer to undo that.
const HELD_COHORTS = ['escape', 'param', 'optout'];

function AppVersionUpdateService($injector, $q, $window, loggerService) {
  this.showAlertIfAppVersionUpdateRequired = () =>
    this.performVersionCheck().then((requireVersionUpdate) => {
      if (!requireVersionUpdate) {
        return null;
      }
      const uibModal = $injector.get('$uibModal');
      const modalInstance = uibModal.open({
        animation: true,
        windowClass: 'modal-sm',
        backdrop: 'static',
        template:
          '<lt-app-version-update ' +
          'on-cancel="modalCtrl.dismiss()" ' +
          'on-emit="modalCtrl.emit()"> ' +
          '</lt-app-version-update>',
        // Not method shorthand, and not an arrow: Angular instantiates a controller with new, and
        // neither form is constructable. The modal spec stubs $uibModal.open, so this would fail
        // only in the browser.
        // eslint-disable-next-line object-shorthand
        controller: function () {
          this.dismiss = () => modalInstance.close();
          this.emit = () => {
            $window.location.reload();
            modalInstance.close();
          };
        },
        controllerAs: 'modalCtrl'
      });

      return modalInstance;
    });

  /**
   * Whether to prompt the visitor to refresh onto the build the server would serve them now.
   *
   * Asked of the server, not a static file: once a baseline or canary is in play there is no single
   * "latest build" to compare against.
   *
   * Cannot loop -- window.frontendVersion is what this document loaded, so after a refresh it
   * equals what the endpoint returns.
   *
   * Held cohorts (escape, param, optout) are never prompted, and cost no request.
   */
  this.performVersionCheck = () => {
    if (HELD_COHORTS.includes($window.frontendCohort)) {
      return $q.resolve(false);
    }

    return $injector
      .get('$http')
      .get(VERSION_ENDPOINT)
      .then((result) => {
        const served = result?.data?.version;

        return Boolean(served) && served !== $window.frontendVersion;
      })
      .catch((error) => {
        loggerService.error('Could not read the served frontend version', { exception: error });

        // A refresh the visitor did not need is worse than a missed one.
        return false;
      });
  };
}

App.service('AppVersionUpdateService', ['$injector', '$q', '$window', 'loggerService', AppVersionUpdateService]);
